import { LeyendaModalForm } from "./LeyendaModalForm"


const LeyendaModalFormWrapper = () => {
    return (<LeyendaModalForm />)
}

export {LeyendaModalFormWrapper}